import { Link } from "react-router-dom";
import { useLang } from "../contexts/LangContext";

const Footer = () => {
    const { t } = useLang();

    return (
        <footer
            data-testid="site-footer"
            className="bg-[#0F0F0E] text-[#EBE8E3]"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 pt-24 md:pt-32 pb-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
                    <div className="md:col-span-6">
                        <div className="font-serif text-4xl md:text-6xl leading-[0.95] tracking-tight max-w-xl">
                            MM Byggeri
                            <br />
                            <span className="italic font-light text-[#D9D4CD]">
                                & Rådgivning
                            </span>
                        </div>
                        <p className="mt-8 text-sm tracking-luxury uppercase text-[#888]">
                            {t.footer.tag}
                        </p>

                        {/* Børsen Gazelle badge */}
                        <div className="mt-10 inline-flex items-center gap-3 border border-[#D9D4CD]/30 px-4 py-3">
                            <span className="font-serif italic text-[#D9D4CD] text-lg">
                                Børsen
                            </span>
                            <span className="text-[10px] tracking-luxury uppercase text-[#888] border-l border-[#D9D4CD]/30 pl-3">
                                Gazelle
                            </span>
                        </div>
                    </div>

                    <div className="md:col-span-2">
                        <h4 className="text-[11px] tracking-luxury uppercase text-[#888] mb-4">
                            {t.footer.navigation}
                        </h4>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <Link
                                    to="/cases"
                                    data-testid="footer-link-cases"
                                    className="link-underline"
                                >
                                    {t.nav.cases}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/privat"
                                    data-testid="footer-link-private"
                                    className="link-underline"
                                >
                                    {t.nav.private}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/arkitekter"
                                    data-testid="footer-link-arch"
                                    className="link-underline"
                                >
                                    {t.nav.architects}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/om-os"
                                    data-testid="footer-link-about"
                                    className="link-underline"
                                >
                                    {t.nav.about}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/kontakt"
                                    data-testid="footer-link-contact"
                                    className="link-underline"
                                >
                                    {t.nav.contact}
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <h4 className="text-[11px] tracking-luxury uppercase text-[#888] mb-4">
                            {t.footer.visit}
                        </h4>
                        <p className="text-sm leading-relaxed whitespace-pre-line">
                            {t.contact.studioAddress}
                        </p>
                    </div>

                    <div className="md:col-span-2">
                        <h4 className="text-[11px] tracking-luxury uppercase text-[#888] mb-4">
                            {t.footer.connect}
                        </h4>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <a
                                    href="mailto:mm@mmbr.dk"
                                    data-testid="footer-email"
                                    className="link-underline break-all"
                                >
                                    mm@mmbr.dk
                                </a>
                            </li>
                            <li>
                                <a
                                    href="tel:+4529369165"
                                    data-testid="footer-phone"
                                    className="link-underline"
                                >
                                    +45 29 36 91 65
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.instagram.com/mm_byggeri_og_radgivning/"
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid="footer-instagram"
                                    className="link-underline"
                                >
                                    Instagram
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-20 pt-8 border-t border-[#2A2825] flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[11px] tracking-luxury uppercase text-[#888]">
                    <div>
                        © {new Date().getFullYear()}  ·  {t.footer.companyLegal}  ·  {t.footer.cvr} 40948694
                    </div>
                    <div className="flex items-center gap-6">
                        <Link
                            to="/cookie-politik"
                            data-testid="footer-cookie"
                            className="hover:text-white transition-colors"
                        >
                            {t.footer.cookiePolicy}
                        </Link>
                        <Link
                            to="/vilkaar"
                            data-testid="footer-terms"
                            className="hover:text-white transition-colors"
                        >
                            {t.footer.terms}
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
